import React from 'react';
import {IElementLikertScale} from '../../../../incase-domain/elements/question/likertScale';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import DebouncedLikertScaleSlider from '../../../../incase-domain/components/slider/DebouncedLikertScaleSlider';

function LikertScaleQuestions(props: IQuestionElementProps<IElementLikertScale>): JSX.Element {
    const {element} = props;

    return (
        <div className="c-likertScale ">
            {element.questions.map((question) => (
                <div
                    key={question.id}
                    style={{
                        fontSize: `${element.fontSize || 'initial'}em`,
                        fontFamily: element.fontFamily?.name,
                    }}
                    className="c-likertScale__sliderQuestion"
                >
                    {question.text}
                    <div className="c-likertScale__sliderQuestion_slider">
                        <DebouncedLikertScaleSlider
                            min={1}
                            max={element.scale.length}
                            step={1}
                            value={3}
                            marks={element.scale.reduce((acc, scale, index) => ({...acc, [index + 1]: scale.text}), {})}
                            onChange={() => undefined}
                            variant="likertScale"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default LikertScaleQuestions;
